import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {LanguageService} from "../service/language.service";
import {Languages} from "../model/languages";

@Injectable()
export class LanguagesResolve implements Resolve<Languages> {
    constructor(private languageService: LanguageService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Languages> {
        return this.languageService.getAll(0, 100);
    }
}